import { useGetPricingVersionQuery } from '@app/api/team'
import useIsFeatureEnabled from '@app/hooks/useIsFeatureEnabled'

/**
 * Hook to determine if the current pricing plan is version 2.
 * To be used in all components that require pricing plan information.
 * @param {string} teamUuid - The UUID of the team.
 * @param {Object} options - Optional configuration object.
 * @param {boolean} [options.skip] - Whether to skip the API query. When true, the hook will not make the API call.
 * @returns {Object} - An object containing isError, isLoading, isPricingPlanV2 and isEnabled properties.
 */

const useIsPricingPlanV2 = (
	teamUuid: string,
	{ skip }: { skip?: boolean } = {},
): {
	isError: boolean
	isLoading: boolean
	isPricingPlanV2: boolean
	isEnabled: boolean
} => {
	const { data: plan, isLoading, isError } = useGetPricingVersionQuery({ teamUuid }, { skip })
	const isPricingV2FeatureEnabled = useIsFeatureEnabled('growthPricingV2')

	return {
		isError: isError,
		isLoading,
		isEnabled: isPricingV2FeatureEnabled,
		isPricingPlanV2: plan?.version === 'v2',
	}
}

export default useIsPricingPlanV2
